import axios from "axios";

const registrationStore = {
  state: {
    loading: null,
    step: 1,
    type: "personal",
    locale: "en-US",
    locale_id: null,
    npi_results: "",
    npi_checked: null,
    npi_info: null,
    var_reseller: "ces",
    valid_parameters: null,
    vendor_results: [],
    checked_reseller: null,
    vendor_status: null,
    welcome_msg: null,
    registration_errors: [],
    error_alert: null,
    uppercase: false,
    lowercase: false,
    digits: false,
    symbol: false,
    matching: false,
    amount: false,
    customer_segment: null,
  },
  mutations: {
    LOADING(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.loading = val;
    },
    SET_NEXT_STEP(state, nextStep) {
      // eslint-disable-next-line no-param-reassign
      state.step = nextStep;
    },
    SET_PREV_STEP(state, prevStep) {
      // eslint-disable-next-line no-param-reassign
      state.step = prevStep;
    },
    SET_REGISTRATION_TYPE(state, formType) {
      // eslint-disable-next-line no-param-reassign
      state.type = formType;
    },
    SET_CUSTOMER_SEGMENT(state, customerSegment) {
      // eslint-disable-next-line no-param-reassign
      state.customer_segment = customerSegment;
    },
    SET_LOCALE(state, locale) {
      // eslint-disable-next-line no-param-reassign
      state.locale = locale;
    },
    SET_NPI_RESULTS(state, results) {
      // eslint-disable-next-line no-param-reassign
      state.npi_results = results.data.data;
    },
    SET_NPI_CHECKED(state, status) {
      // eslint-disable-next-line no-param-reassign
      state.npi_checked = status;
    },
    SET_NPI_INFO(state, info) {
      // eslint-disable-next-line no-param-reassign
      state.npi_info = info;
    },
    SET_VAR_RESELLER(state, varName) {
      // eslint-disable-next-line no-param-reassign
      state.var_reseller = varName;
    },
    SET_VALID_PARAMETERS(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.valid_parameters = data;
    },
    SET_VENDOR_RESULTS(state, results) {
      // eslint-disable-next-line no-param-reassign
      state.vendor_results = results;
    },
    SET_CHECKED_RESELLER(state, varReseller) {
      // eslint-disable-next-line no-param-reassign
      state.checked_reseller = varReseller;
    },
    SET_VENDOR_STATUS(state, status) {
      // eslint-disable-next-line no-param-reassign
      state.vendor_status = status;
    },
    RESET_NPI_SEARCH_RESULTS(state) {
      // eslint-disable-next-line no-param-reassign
      state.npi_results = [];
    },
    PUSH_REGISTRATION_ERROR(state, error) {
      state.registration_errors.push(error);
    },
    CLEAR_ERROR_MSG(state) {
      // eslint-disable-next-line no-param-reassign
      state.registration_errors = [];
    },
    WELCOME_MSG(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.welcome_msg = val;
    },
    ERROR_ALERT(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.error_alert = val;
    },
    SET_UPPERCASE(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.uppercase = val;
    },
    SET_LOWERCASE(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.lowercase = val;
    },
    SET_DIGITS(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.digits = val;
    },
    SET_SYMBOL(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.symbol = val;
    },
    SET_MATCHING(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.matching = val;
    },
    SET_AMOUNT(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.amount = val;
    },
    SET_LOCALE_ID(state, localeId) {
      // eslint-disable-next-line no-param-reassign
      state.locale_id = localeId;
    },
  },
  actions: {
    nextStep({ commit, state, dispatch }) {
      if (state.step === 1 && state.customer_segment.slug === "procom") {
        dispatch("setLocaleId", "en-US");
        commit("SET_LOCALE", "en-US");
        commit("SET_NPI_CHECKED", true);
        commit("SET_NPI_INFO", "none");
        commit("SET_NEXT_STEP", 5);
      } else if (state.step === 2 && state.locale === "en-CA") {
        commit("SET_NEXT_STEP", 5);
      } else {
        commit("SET_NEXT_STEP", state.step + 1);
      }
    },

    prevStep({ commit, state }) {
      if (state.step === 5) {
        commit("SET_VENDOR_RESULTS", []);
        commit("SET_CHECKED_RESELLER", null);
      }
      if (state.step === 5 && state.locale === "en-CA") {
        commit("SET_PREV_STEP", 2);
      } else if (state.step === 5 && state.customer_segment.slug === "procom") {
        commit("SET_NPI_CHECKED", false);
        commit("SET_NPI_INFO", null);

        commit("SET_PREV_STEP", 1);
      } else {
        commit("SET_PREV_STEP", state.step - 1);
      }
    },

    setCustomerSegment({ commit }, customerSegment) {
      commit("SET_CUSTOMER_SEGMENT", customerSegment);
    },

    setLocale({ commit }, locale) {
      commit("SET_LOCALE", locale);
    },

    setFormType({ commit }, formType) {
      commit("SET_REGISTRATION_TYPE", formType);
    },

    setNpiChecked({ commit }, status) {
      commit("SET_NPI_CHECKED", status);
    },

    setNpiInfo({ commit }, data) {
      commit("SET_NPI_INFO", data);
    },

    setVarReseller({ commit }, varName) {
      commit("SET_VAR_RESELLER", varName);
    },

    setValidParameters({ commit }, parameters) {
      commit("SET_VALID_PARAMETERS", parameters);
    },

    setCheckedVarReseller({ commit }, varReferrer) {
      commit("SET_CHECKED_RESELLER", varReferrer);
    },

    reSetNpiInfo({ commit }) {
      commit("SET_NPI_INFO", null);
    },

    resetNpiSearchResults({ commit }) {
      commit("RESET_NPI_SEARCH_RESULTS");
    },

    setLoading({ commit }, val) {
      commit("LOADING", val);
    },

    setUppercase({ commit }, val) {
      commit("SET_UPPERCASE", val);
    },

    setLowercase({ commit }, val) {
      commit("SET_LOWERCASE", val);
    },

    setDigits({ commit }, val) {
      commit("SET_DIGITS", val);
    },

    setSymbol({ commit }, val) {
      commit("SET_SYMBOL", val);
    },

    setMatching({ commit }, val) {
      commit("SET_MATCHING", val);
    },

    setAmount({ commit }, val) {
      commit("SET_AMOUNT", val);
    },

    registrationValidationForm({ commit, dispatch }, fields) {
      commit("CLEAR_ERROR_MSG");
      dispatch("validateEmpty", fields);
      dispatch("validateLength", fields);
      dispatch("validatePhone", fields);
      dispatch("validatePassword", fields);
      dispatch("validateEmail", fields);
    },

    validateValidParameters({ commit, state }) {
      if (state.valid_parameters.locale !== null) {
        if (
          state.valid_parameters.locale !== state.locale ||
          !state.valid_parameters.customer_segment_ids.some(
            (segmentId) => segmentId === state.customer_segment.id
          )
        ) {
          commit("SET_VAR_RESELLER", null);
        } else {
          commit("SET_CHECKED_RESELLER", state.var_reseller);
        }
      }
    },

    validateEmpty({ commit, state }, fields) {
      const msg = "can't be empty.";
      Object.keys(fields).forEach((key) => {
        if (state.step === 2 || state.step === 5) {
          if (!fields[key] && key === "first_name ") {
            commit("PUSH_REGISTRATION_ERROR", `First Name ${msg}`);
          }
          if (!fields[key] && key === "last_name") {
            commit("PUSH_REGISTRATION_ERROR", `Last Name ${msg}`);
          }
          if (!fields[key] && key === "company") {
            commit("PUSH_REGISTRATION_ERROR", `Organization Name ${msg}`);
          }
          if (!fields[key] && key === "email") {
            commit("PUSH_REGISTRATION_ERROR", `Email ${msg}`);
          }
          if (!fields[key] && key === "phone") {
            commit("PUSH_REGISTRATION_ERROR", `Phone ${msg}`);
          }
          if (!fields[key] && key === "password") {
            commit("PUSH_REGISTRATION_ERROR", `Password ${msg}`);
          }
          if (!fields[key] && key === "password_confirmation") {
            commit("PUSH_REGISTRATION_ERROR", `Password Confirmation ${msg}`);
          }
        }
      });
    },

    validateLength({ commit, state }, fields) {
      const msg = "the max amount of characters are 255.";
      Object.keys(fields).forEach((key) => {
        if (state.step === 2 || state.step === 5) {
          if (key === "first_name" && fields[key].length > 256) {
            commit("PUSH_REGISTRATION_ERROR", `First Name: ${msg}`);
          }
          if (key === "last_name" && fields[key].length > 256) {
            commit("PUSH_REGISTRATION_ERROR", `Last Name: ${msg}`);
          }
          if (key === "company" && fields[key].length > 256) {
            commit("PUSH_REGISTRATION_ERROR", `Organization Name ${msg}`);
          }
          if (key === "email" && fields[key].length > 256) {
            commit("PUSH_REGISTRATION_ERROR", `Email ${msg}`);
          }
          if (key === "phone" && fields[key].length > 256) {
            commit("PUSH_REGISTRATION_ERROR", `Phone ${msg}`);
          }
          if (key === "password" && fields[key].length > 256) {
            commit("PUSH_REGISTRATION_ERROR", `Password ${msg}`);
          }
          if (key === "password_confirmation" && fields[key].length > 256) {
            commit("PUSH_REGISTRATION_ERROR", `Password Confirmation ${msg}`);
          }
        }
      });
    },

    validateEmail({ commit, state }, fields) {
      Object.keys(fields).forEach(async (key) => {
        if (state.step === 2 || state.step === 5) {
          if (key === "email") {
            try {
              const email = fields[key];
              const data = { email };
              const response = await axios.post("/email-check", data);
              if (response.data.email) {
                commit("PUSH_REGISTRATION_ERROR", `${email} already exist.`);
              }
            } catch (error) {
              commit("WELCOME_MSG", true);
            }
          }
        }
      });
    },

    validatePhone({ commit, state }, fields) {
      Object.keys(fields).forEach((key) => {
        if (state.step === 2 || state.step === 5) {
          if (key === "phone" && fields[key]) {
            const numbers = /^\d+(-\d+)*$/;
            if (!fields[key].match(numbers)) {
              commit("PUSH_REGISTRATION_ERROR", "Check the phone format.");
            }
          }
        }
      });
    },

    validatePassword({ commit, state }, fields) {
      const passwords = [];
      Object.keys(fields).forEach((key) => {
        if (state.step === 2 || state.step === 5) {
          if (key === "password" && fields[key]) {
            const password = fields[key];
            passwords.push(password);
            const upper = /[A-Z]/m;
            const lower = /[a-z]/m;
            const digits = /\d/m;
            const symbols = /[\W_]/m;

            if (!upper.test(password)) {
              commit(
                "PUSH_REGISTRATION_ERROR",
                "Password is missing a capital letter"
              );
            }
            if (!lower.test(password)) {
              commit(
                "PUSH_REGISTRATION_ERROR",
                "Password is missing a lower case letter"
              );
            }
            if (!digits.test(password)) {
              commit("PUSH_REGISTRATION_ERROR", "Password is missing a number");
            }
            if (!symbols.test(password)) {
              commit("PUSH_REGISTRATION_ERROR", "Password is missing a symbol");
            }
          }
          if (key === "password_confirmation" && fields[key]) {
            const passwordConfirmation = fields[key];
            passwords.push(passwordConfirmation);
          }
        }
      });

      if (passwords.length === 2 && passwords[0] !== passwords[1]) {
        commit(
          "PUSH_REGISTRATION_ERROR",
          "Password confirmation doesn't match"
        );
      }
    },

    async setLocaleId({ commit }, localeName) {
      try {
        if (localeName) {
          const response = await axios.get(`/local-id/${localeName}`);
          if (response.status === 200) {
            commit("SET_LOCALE_ID", response.data.locale_id);
          } else {
            commit("SET_LOCALE_ID", 1);
          }
        }
      } catch (error) {
        commit("SET_LOCALE_ID", 1);
      }
    },

    async createNewAccount({ commit, state }, fields) {
      commit("LOADING", false);
      try {
        if (state.registration_errors.length === 0) {
          commit("LOADING", true);
          const response = await axios.post("/register", fields);
          if (response.status === 201) {
            window.location.href = "/account";
            commit("LOADING", false);
            commit("WELCOME_MSG", true);
          } else {
            commit("ERROR_ALERT", true);
          }
        }
      } catch (error) {
        commit("ERROR_ALERT", true);
      }
    },

    async getNpiRecords({ commit }, formFields) {
      try {
        commit("LOADING", true);
        const response = await axios.post("/npi", formFields);
        commit("SET_NPI_RESULTS", response);
        commit("LOADING", false);
      } catch (error) {
        commit("ERROR_ALERT", true);
      }
    },

    async searchVendor({ commit, state }, criteria) {
      try {
        const response = await axios.get("/register/search-vars", {
          params: {
            locale_id: state.locale_id,
            customer_segment_id: state.customer_segment.id,
            term: criteria,
          },
        });

        if (response.data.length === 0) {
          commit("SET_VENDOR_STATUS", "empty");
        } else {
          commit("SET_VENDOR_STATUS", null);
        }
        commit("SET_VENDOR_RESULTS", response.data);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        commit("ERROR_ALERT", true);
      }
    },
  },
};

export default registrationStore;
